export default __webpack_public_path__ + "static/media/ic-upload-file.91185a54.svg";